import React from 'react';
import { Seo } from '../components/Seo';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { AboutPreview } from '../components/AboutPreview';
import { ServicesSection } from '../components/ServicesSection';
import { FeaturedProject } from '../components/FeaturedProject';
import { WhyMorvix } from '../components/WhyMorvix';
import { ClientLogos } from '../components/ClientLogos';
import { ConsultationCTA } from '../components/ConsultationCTA';
import { seo } from '../data/site';
const marqueeItems = ['Brand Identity', 'Logo Design', 'Packaging', 'Motion', 'Web Design', 'Print', 'Social Media', 'Illustration'];

/**
 * Homepage = overview only.
 * Each section is a short preview that routes visitors to its dedicated page:
 * Services → /services, Work → /work, About → /about, Contact → /contact.
 */
export function Home() {
  return <>
      <Seo title={seo.defaultTitle} description={seo.defaultDescription} path="/" data-id="element-718" data-mp="3ovubnwsd3rku" />
      <Hero data-id="element-719" data-mp="30xb5vtu56frz" />
      <Marquee items={marqueeItems} data-id="element-720" data-mp="30vqcw8nh74w8" />
      <AboutPreview data-id="element-721" data-mp="30up1g32jsgdz" />
      <ServicesSection limit={6} withCta data-id="element-722" data-mp="2vxoulpxvj9lt" />
      <FeaturedProject withGallery={false} data-id="element-723" data-mp="2vyq4vs72fs2h" />
      <WhyMorvix data-id="element-724" data-mp="2vvvocbr6arec" />
      <ClientLogos data-id="element-725" data-mp="2qybzkhwumw85" />
      <ConsultationCTA data-id="element-726" data-mp="2qxu4holxao1t" />
    </>;
}